import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import AutocodeDictionaryTab from './AutocodeDictionaryTab';
import AutocodeDefinitionsTab from './AutocodeDefinitionsTab';
import { CO1_DEF_TAB, COMPOSER_SUBMODULE } from '../../trackerConstants';
import { saveTrackingData } from '../../util/trackerUtils';
// import ACSelectionBoxContext from './ACContext/ACSelectionBoxContext';
// import autocodeSelectionReducer from './ACContext/acSelectionBoxReducer';
// import { AC_ROOT_NODE_ID } from './AutocodeConstants';

const AutocodeTabs = ({
  moduleStudy,
  activeAccountId,
  uid,
  selectedWeightType,
  gridData,
  // trackerFn,
  editMode,
  backToDef,
  createDefMode,
  moduleAction,
  // partsToShow,
  tabIndex,
  settabIndex,
  menuName,
}) => {
  // const [tabIndex, settabIndex] = useState(0);
  // const [state, dispatch] = useReducer(autocodeSelectionReducer, {
  //   setTabsIndex: tab => {
  //     settabIndex(tab);
  //   },
  //   partsToShow,
  //   allOpNodes: [],
  //   topLevelOpNodes: [],
  //   rootNode: {
  //     type: 'root',
  //     id: AC_ROOT_NODE_ID,
  //     selected: false,
  //     combined: false,
  //     children: [],
  //     // eslint-disable-next-line no-unused-vars
  //     toLabelString(pts) {
  //       return '';
  //     },
  //     toExpressionString() {
  //       return '';
  //     },
  //     toExpressionArray() {
  //       return [];
  //     },
  //   },
  // });
  const handleTabSelect = tabIndex => {
    if(tabIndex === 1 && !backToDef){
      saveTrackingData({
        uid,
        accid: activeAccountId,
        productNo: moduleStudy.pn,
        moduleName: menuName,
        subModule: COMPOSER_SUBMODULE,
        action: CO1_DEF_TAB,
      });
    }
    settabIndex(tabIndex);
  };

  useEffect(() => {
    if (backToDef) handleTabSelect(1);
  }, [backToDef]);
  return (
    <Tabs selectedIndex={tabIndex} onSelect={handleTabSelect}>
      {!(editMode || createDefMode) && (
        <TabList className="autocode-tabs">
          <Tab>Dictionary</Tab>
          <Tab>Definitions</Tab>
        </TabList>
      )}
      {/* <ACSelectionBoxContext.Provider
        value={{
          state,
          dispatch,
          trackerFn,
        }}
      > */}
      <TabPanel>
        <AutocodeDictionaryTab
          moduleStudy={moduleStudy}
          activeAccountId={activeAccountId}
          uid={uid}
          selectedWeightType={selectedWeightType}
          gridData={gridData}
          moduleAction={moduleAction}
          menuName={menuName}
        />
      </TabPanel>
      <TabPanel>
        <AutocodeDefinitionsTab
          moduleStudy={moduleStudy}
          uid={uid}
          selectedWeightType={selectedWeightType}
          gridData={gridData}
          backToDef={backToDef}
          moduleAction={moduleAction}
          menuName={menuName}
        />
      </TabPanel>
      {/* </ACSelectionBoxContext.Provider> */}
    </Tabs>
  );
};

AutocodeTabs.propTypes = {
  moduleStudy: PropTypes.shape({
    pn: PropTypes.number,
  }),
  activeAccountId: PropTypes.number,
  uid: PropTypes.number,
  selectedWeightType: PropTypes.shape({}),
  gridData: PropTypes.shape({
    BasesDataGrid: PropTypes.arrayOf(PropTypes.object),
    ColumnsDataGrid: PropTypes.arrayOf(PropTypes.object),
    RowsDataGrid: PropTypes.arrayOf(PropTypes.object),
  }),
  // trackerFn: PropTypes.func,
  editMode: PropTypes.bool,
  createDefMode: PropTypes.bool,
  backToDef: PropTypes.bool,
  tabIndex: PropTypes.number,
  settabIndex: PropTypes.func,
  moduleAction: PropTypes.shape({}),
  menuName: PropTypes.string,
};

export default AutocodeTabs;
